export const API_BASE_URL = 'https://nodejs-appli.visamonde.com';
//https://nodejs-appli.visamonde.com
// http://localhost:3001

// Adresse des fichiers (visas, e-cards) : suit API_BASE_URL, rien à changer à la main.
// En local, C:\wamp64\www\commons est servi par l'Apache de WAMP.
export const FILES_BASE_URL = API_BASE_URL.includes('localhost')
  ? 'http://localhost/commons'
  : 'https://common.visamonde.com';